var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "media-upload" },
    [
      _c(
        "el-upload",
        {
          attrs: {
            action: "#",
            accept: _vm.accept,
            "show-file-list": false,
            disabled: _vm.uploading,
            "before-upload": _vm.beforeUpload,
            "http-request": _vm.uploadFile,
          },
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                plain: "",
                loading: _vm.uploading,
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.uploading
                    ? "上传中 " + _vm.progress + "%"
                    : _vm.uploadLabel
                )
              ),
            ]
          ),
        ],
        1
      ),
      _vm.uploading
        ? _c(
            "el-button",
            {
              attrs: { type: "text", size: "small" },
              on: { click: _vm.cancelUpload },
            },
            [_vm._v("取消上传")]
          )
        : _vm._e(),
      _vm.type === "POLICY"
        ? _c("p", { staticClass: "upload-hint" }, [
            _vm._v(
              "支持 Word、Excel、PPT、PDF，单个文件不超过 20 GB，最多 20 个"
            ),
          ])
        : _vm.type === "TEMPLATE"
        ? _c("p", { staticClass: "upload-hint" }, [
            _vm._v(
              "支持 Word、Excel、PPT、PDF 和 JPG、PNG、GIF、WebP 图片，每个模板可添加 1 至 8 个文件，单文件最大 200 MB"
            ),
          ])
        : _c("p", { staticClass: "upload-hint" }, [
            _vm._v(
              "支持 JPG、PNG、GIF、WebP 图片（10 MB 内）及 MP4 视频（单文件 20 GB 内），最多 20 个"
            ),
          ]),
      _vm._l(_vm.attachments, function (item) {
        return _c(
          "div",
          { key: item.url, staticClass: "media-row" },
          [
            item.kind === "IMAGE"
              ? _c("img", { attrs: { src: item.url, alt: "图片缩略图" } })
              : _c("i", {
                  class:
                    item.kind === "VIDEO"
                      ? "el-icon-video-camera"
                      : "el-icon-document",
                }),
            _c(
              "a",
              {
                attrs: {
                  href: item.url,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  title: item.name,
                },
              },
              [_vm._v(_vm._s(item.name))]
            ),
            _c("span", [
              _vm._v(
                _vm._s(_vm.size(item.size)) +
                  _vm._s(
                    item.kind === "VIDEO"
                      ? " · " + item.durationSeconds + "秒"
                      : ""
                  )
              ),
            ]),
            _c(
              "el-button",
              {
                staticClass: "remove",
                attrs: { type: "text", disabled: _vm.uploading },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.remove(item.url)
                  },
                },
              },
              [_vm._v("移除")]
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }